import { Mark } from '@tiptap/core'

const Background = Mark.create({
  name: 'background',

  addOptions () {
    return {
      markid: [''],
      color: ['#F2E038'],
      background: [''],
      subdomain: ['']
    }
  },

  inclusive: false,

  addAttributes () {
    return {
      markid: {
        default: false,
        parseHTML: element => {
          return element.getAttribute('datamark') || element.getAttribute('dataMark') || ''
        }
      },
      color: {
        default: '#F2E038',
        parseHTML: element => {
          return element.getAttribute('datacolor') || element.getAttribute('dataColor') || '#F2E038'
        }
      },
      subdomain: {
        default: '',
        parseHTML: element => {
          return element.getAttribute('sdata') || ''
        }
      }
    }
  },

  parseHTML () {
    return [
      {
        tag: 'bg-marker'
      }
    ]
  },

  renderHTML ({ HTMLAttributes }) {
    const markid = HTMLAttributes.markid || HTMLAttributes.dataMark || ''
    const color = HTMLAttributes.color || HTMLAttributes.dataColor || '#F2E038'
    const subdomain = HTMLAttributes.subdomain || HTMLAttributes.sdata || ''

    const attrs = {
      ...HTMLAttributes,
      class: `mark-${markid}`,
      style: `background:url(https://${subdomain}.estage.site/api/mark?color=${color}&shape=${markid})`,
      dataMark: markid,
      dataColor: color,
      sdata: subdomain
    }

    delete attrs.markid
    delete attrs.color
    delete attrs.subdomain

    return ['bg-marker', attrs, 0]
  },

  addCommands () {
    return {
      background: attrs => ({ commands }) => {
        if (!attrs) {
          return commands.unsetMark(this.name)
        }

        return commands.setMark(this.name, attrs)
      }
    }
  }
})

export default Background
